import { render, staticRenderFns } from "./DialogChangeTicketStatus.vue?vue&type=template&id=0cbf4f32"
import script from "./DialogChangeTicketStatus.vue?vue&type=script&lang=js"
export * from "./DialogChangeTicketStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports